import { Injectable } from '@angular/core';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action, Store } from '@ngrx/store';

import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as applicationActions from '../../stateManagement/actions/containers/application';
import * as _ from 'lodash';
import * as commonTypes from '../../shared/types';
import { VersionCheckerService } from '../services/version-checker.service';

@Injectable()
export class ApplicationVersionEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IApplicationState>,
    private versionCheckerService: VersionCheckerService
  ) {}

    @Effect({ dispatch: false })
    updateAppVersion$ = this.actions$
      .ofType(applicationActions.ActionTypes.APP_UPDATE_VERSION)
      .map(() => this.versionCheckerService.updateVersion());
  
    @Effect({ dispatch: false })
    checkForNewAppVersion$ = this.actions$
      .ofType(applicationActions.ActionTypes.APP_CHECK_VERSION)
      .map(() => this.versionCheckerService.checkForVersion());
}



// WEBPACK FOOTER //
// ./src/app/shared/effects/appVersion.effect.ts